// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../Booker.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../Booker.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.password-input-wrapper[data-v-2f6cbed5] {
  position: relative;
  display: flex;
  align-items: center;
}
.password-input[data-v-2f6cbed5] {
    width: calc(100% - 80px);
    margin-bottom: 0px;
    height: 20px !important;
    padding: 10px 20px;
    padding-right: 50px;
    color: #222c3c;
    font-weight: normal;
    font-size: 14px;
    line-height: unset;
    font-weight: 500;
    border-radius: 5px;
    border: 1px solid #ced4da;
}
.password-input[data-v-2f6cbed5]:focus {
  outline: none;
  border-color: #005EB8;
  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.2);
}
.password-input[data-v-2f6cbed5]:disabled {
  background-color: #F0F4F5;
  cursor: not-allowed;
  opacity: 0.7;
}
.password-input[data-v-2f6cbed5]::placeholder {
  color: #6C757D;
}
.password-toggle[data-v-2f6cbed5] {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #6C757D;
  font-size: 16px;
  transition: color 0.2s ease;
  z-index: 1;
}
.password-toggle[data-v-2f6cbed5]:hover {
  color: #495057;
}
.password-toggle[data-v-2f6cbed5]:focus {
  outline: none;
}
.password-toggle[data-v-2f6cbed5]:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.password-toggle i[data-v-2f6cbed5] {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./../Osc.Common/Frontend/passwords/components/passwordinput.vue"],"names":[],"mappings":";AA8DA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AACA;AAEA;IACA,wBAAA;IACA,kBAAA;IACA,uBAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;IACA,yBAAA;AACA;AAEA;EACA,aAAA;EACA,qBAAA;EACA,2CAAA;AACA;AAEA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;AACA;AAEA;EACA,cAAA;AACA;AAEA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,UAAA;AACA;AAEA;EACA,cAAA;AACA;AAEA;EACA,aAAA;AACA;AAEA;EACA,mBAAA;EACA,YAAA;AACA;AAEA;EACA,oBAAA;AACA","sourcesContent":["<template>\r\n  <div class=\"password-input-wrapper\">\r\n    <input\r\n      :id=\"id\"\r\n      :type=\"showPassword ? 'text' : 'password'\"\r\n      :value=\"value\"\r\n      :placeholder=\"placeholder\"\r\n      :disabled=\"disabled\"\r\n      @input=\"$emit('input', $event.target.value)\"\r\n      @focus=\"$emit('focus')\"\r\n      @blur=\"$emit('blur')\"\r\n      class=\"password-input\"\r\n      autocomplete=\"new-password\"\r\n    />\r\n    <button\r\n      type=\"button\"\r\n      class=\"password-toggle\"\r\n      @click=\"togglePasswordVisibility\"\r\n      :disabled=\"disabled\"\r\n      :aria-label=\"showPassword ? 'Hide password' : 'Show password'\"\r\n    >\r\n      <i :class=\"showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'\"></i>\r\n    </button>\r\n  </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n  name: 'PasswordInput',\r\n  props: {\r\n    id: {\r\n      type: String,\r\n      default: ''\r\n    },\r\n    value: {\r\n      type: String,\r\n      default: ''\r\n    },\r\n    placeholder: {\r\n      type: String,\r\n      default: 'Enter password'\r\n    },\r\n    disabled: {\r\n      type: Boolean,\r\n      default: false\r\n    }\r\n  },\r\n  data() {\r\n    return {\r\n      showPassword: false\r\n    };\r\n  },\r\n  methods: {\r\n    togglePasswordVisibility() {\r\n      this.showPassword = !this.showPassword;\r\n    }\r\n  },\r\n  emits: ['input', 'focus', 'blur']\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.password-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.password-input {\r\n    width: calc(100% - 80px);\r\n    margin-bottom: 0px;\r\n    height: 20px !important;\r\n    padding: 10px 20px;\r\n    padding-right: 50px;\r\n    color: #222c3c;\r\n    font-weight: normal;\r\n    font-size: 14px;\r\n    line-height: unset;\r\n    font-weight: 500;\r\n    border-radius: 5px;\r\n    border: 1px solid #ced4da;\r\n}\r\n\r\n.password-input:focus {\r\n  outline: none;\r\n  border-color: #005EB8;\r\n  box-shadow: 0 0 0 3px rgba(0, 94, 184, 0.2);\r\n}\r\n\r\n.password-input:disabled {\r\n  background-color: #F0F4F5;\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.password-input::placeholder {\r\n  color: #6C757D;\r\n}\r\n\r\n.password-toggle {\r\n  position: absolute;\r\n  right: 12px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 8px;\r\n  color: #6C757D;\r\n  font-size: 16px;\r\n  transition: color 0.2s ease;\r\n  z-index: 1;\r\n}\r\n\r\n.password-toggle:hover {\r\n  color: #495057;\r\n}\r\n\r\n.password-toggle:focus {\r\n  outline: none;\r\n}\r\n\r\n.password-toggle:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.5;\r\n}\r\n\r\n.password-toggle i {\r\n  pointer-events: none;\r\n}\r\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
